(function($) {
  /* ==== MEMBERS ==== */

  /**
   * Member Button Show More
   */
  function memberShowMore(button) {
    var show = button.attr('data-show');
    var member = button
      .parent()
      .parent()
      .parent();
    var details = member.find('.member__details').first();
    var scrollOffset = $('.site-header').innerHeight();

    if (show === 'more') {
      details.removeClass('member__details--hidden');
      button.attr('data-show', 'less');
    } else {
      details.addClass('member__details--hidden');
      button.attr('data-show', 'more');
    }

    $([document.documentElement, document.body])
      .stop()
      .animate(
        {
          scrollTop: member.offset().top - scrollOffset,
        },
        500,
      );
  }

  $('.member__button').each(function() {
    $(this).click(function() {
      memberShowMore($(this));
    });
  });

  /**
   * Load More Members
   */
  var loadMoreButton = $('#loadMoreMembers');
  var postPerPage = loadMoreButton.attr('data-post-per-page');
  var totalPages = loadMoreButton.attr('data-total-pages');
  var pageNumber = 1;

  /**
   * Load More Members Button
   */
  loadMoreButton.click(function(e) {
    e.preventDefault();
    loadMoreMembers();
  });

  /**
   * Load More Members
   */
  function loadMoreMembers() {
    loadMoreButton.attr('disabled', true);

    var searching = parseInt(loadMoreButton.attr('data-searching'));
    var searchInput = $('#searchMembers');
    var searchButton = $('#searchMembersButton');

    searchInput.attr('disabled', true);
    searchButton.attr('disabled', true);

    var searchValue = '';
    if (searching) {
      searchValue = searchInput.val();
    }

    var filterInput = $('#locationFilter');
    var filterValue = filterInput.val();

    console.log(filterValue);

    filterInput.attr('disabled', true);

    var loader = loadMoreButton.next('.members__loading');
    loader.show();

    pageNumber++;

    if (pageNumber === 1) {
      loadMoreButton.hide();
    }

    $.ajax({
      type: 'POST',
      url: ajax_object.ajaxurl,
      action: 'load_more_members',
      data: {
        action: 'load_more_members',
        pageNumber: pageNumber,
        postPerPage: postPerPage,
        searchValue: searchValue,
        filterValue: filterValue,
      },
      success: function(data) {
        var $data = $(data);

        if ($data.length) {
          $('.members__no-result').addClass('d-none');

          var ajaxMembersContainer = $('#ajax-members');
          ajaxMembersContainer.append($data);

          loadMoreButton.show();
          loadMoreButton.attr('disabled', false);

          // If it is the first page, update variables
          if (pageNumber === 1) {
            var totalMembers = ajaxMembersContainer.find('#totalMembers').val();
            if (totalMembers != null) {
              $('#totalMembers').text(totalMembers);
              $('.filters__results').css('display', 'block');
            }

            var newtotalPages = ajaxMembersContainer.find('#totalPages').val();
            if (newtotalPages != null) {
              totalPages = newtotalPages;
            }
          }

          $data.find('.member__button').each(function() {
            $(this).click(function() {
              memberShowMore($(this));
            });
          });
        } else {
          loadMoreButton.hide();

          if (pageNumber === 1) {
            $('#totalMembers').text('0');

            $('.members__no-result').removeClass('d-none');
          }
        }

        searchInput.attr('disabled', false);
        searchButton.attr('disabled', false);
        filterInput.attr('disabled', false);

        if (totalPages <= pageNumber) {
          loadMoreButton.attr('disabled', true);
          loadMoreButton.hide();
        }

        loader.hide();
      },
      error: function(response) {
        console.log('An error occurred while trying to fetch more members.');
        console.log(response);
      },
    });

    return false;
  }

  /**
   * Search Members - Keypress trigger
   */
  $('#searchMembers').on('keypress', function(e) {
    if (e.which == 13) {
      // Enter
      searchMembers();
    }
  });

  /**
   * Search Members - Button trigger
   */
  $('#searchMembersButton').click(function(e) {
    e.preventDefault();
    searchMembers();
  });

  /**
   * Search Members
   */
  function searchMembers() {
    var searchInput = $('#searchMembers');
    var searchValue = searchInput.val();
    var searchMinimumCharWarning = searchInput
      .parent()
      .find('.filters__search-error')
      .first();

    if (searchValue.length < 3 && searchValue.length > 0) {
      searchMinimumCharWarning.removeClass('d-none');
    } else {
      searchMinimumCharWarning.addClass('d-none');

      if (searchValue.length >= 3) {
        loadMoreButton.attr('data-searching', 1);
      } else {
        loadMoreButton.attr('data-searching', 0);
      }

      pageNumber = 0;
      $('#ajax-members').empty();

      loadMoreMembers();
    }
  }

  /**
   * Filter Members
   */
  $('#locationFilter').on('change', function() {
    pageNumber = 0;
    $('#ajax-members').empty();

    var filterValue = $(this).val();
    if (filterValue == '') {
      $('.filters__results').css('display', 'none');
    } else {
      $('.filters__results').css('display', 'block');
      loadMoreMembers();
    }
  });
})(jQuery);
